'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utilsStyleSvg = require('./utils/styleSvg');

var _utilsStyleSvg2 = _interopRequireDefault(_utilsStyleSvg);

var _reactIconsLibMd = require('react-icons/lib/md');

var md = _interopRequireWildcard(_reactIconsLibMd);

var box = function box(props) {
	var style = {};

	//size
	if (!!props.height) style.height = props.height;
	if (!!props.width) style.width = props.width;
	if (!!props.minWidth) style.minWidth = props.minWidth;
	if (!!props.minHeight) style.minHeight = props.minHeight;

	var icon = md[props.icon];

	if (icon === undefined) return _react2['default'].DOM.span(null, 'Icon ' + props.icon + ' is not register among icons.');
	var iconProps = (0, _utilsStyleSvg2['default'])(style, props);
	console.log(iconProps);
	return _react2['default'].createElement(icon, iconProps, null);
};
box.defaultProps = { icon: 'Md3dRotation', minWidth: 100, minHeight: 100 };
exports['default'] = box;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/Icon.js
 ** module id = 2219
 ** module chunks = 0
 **/